/**
 * Store Mutation types
 */
// AUTH
export const AUTH_STATE_CLEARED = 'auth.STATE_CLEARED';
/** Login Request */
export const LOGIN_REQUEST = 'auth.LOGIN_REQUEST';
/** Login Fail */
export const LOGIN_FAIL = 'auth.LOGIN_FAIL';
/** Login Success - store JWT token */
export const LOGIN_SUCCESS = 'auth.LOGIN_SUCCESS';
/** Logout Success - clear all related user's information stored */
export const LOGOUT_SUCCESS = 'auth.LOGOUT_SUCCESS';
/** Refresh Token Success - update stored JWT token */
// export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const TENANT_ID_SET = 'auth.TENANT_ID_SET';
export const HEARTBEAT_REQUEST = 'auth.HEARTBEAT_REQUEST';
export const CHECK_SESSION_REQUEST = 'auth.CHECK_SESSION_REQUEST';
export const HEARTBEAT_SUCCESS = 'auth.HEARTBEAT_SUCCESS';
export const HEARTBEAT_FAIL = 'auth.HEARTBEAT_FAIL';
export const ACTIVE_TIMESTAMP_UPDATED = 'auth.ACTIVE_TIMESTAMP_UPDATED';
// export const FORCE_LOGIN = 'auth.FORCE_LOGIN';
// export const FORCE_LOGOUT = 'auth.FORCE_LOGOUT';
export const CHANGE_PASSWORD_REQUEST = 'auth.CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'auth.CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'auth.CHANGE_PASSWORD_FAIL';
export const RESET_PASSWORD_REQUEST = 'auth.RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'auth.RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'auth.RESET_PASSWORD_FAIL';



// WEBPACK FOOTER //
// ./src/store/mutations/auth.js